package xim.poc.game.configuration.v0.tactics

import xim.math.Vector3f
import xim.poc.ActorController
import xim.poc.game.ActorState
import xim.poc.velocityVectorTo
import xim.util.Fps
import kotlin.time.Duration.Companion.seconds

class MovementCommand(val startPosition: Vector3f, val endPosition: Vector3f) {
    val distance = Vector3f.distance(startPosition, endPosition)
    var complete = false
    var totalTime = 0f
}

class TacticsMovementController: ActorController {

    override fun getVelocity(actorState: ActorState, elapsedFrames: Float): Vector3f {
        val current = actorState.getMovementCommand() ?: return Vector3f.ZERO

        current.totalTime += elapsedFrames
        if (Fps.framesToSeconds(current.totalTime) > 5.seconds) {
            actorState.position.copyFrom(current.endPosition)
            current.complete = true
            return Vector3f.ZERO
        }

        if (current.distance < 1e-3f) {
            current.complete = true
            return Vector3f.ZERO
        }

        val distanceToNow = Vector3f.distance(current.startPosition, actorState.position)
        val velocity = velocityVectorTo(current.startPosition, current.endPosition, actorState.getMovementSpeed(), elapsedFrames)

        if (current.distance - distanceToNow > velocity.magnitude()) {
            if (actorState.isStaggerFrozen()) { actorState.effectVelocity.copyFrom(velocity) }
            return velocity
        }

        actorState.position.copyFrom(current.endPosition)
        current.complete = true

        return Vector3f.ZERO
    }
}